import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Actions from "../../../../../components/Actions";

const Row = ({ item, onJustify, onUnjustify }) => {
    // Actions pour justifier/déjustifier
    const actions = item.justification 
        ? [
            {
                title: "Retirer la justification",
                action: () => onUnjustify && onUnjustify(item)
            }
        ]
        : [
            {
                title: "Marquer comme justifiée",
                action: () => onJustify && onJustify(item)
            }
        ];
    // Formater les horaires depuis une datetime ISO (sans conversion timezone)
    const formatTime = (datetime) => {
        if (!datetime) return '';
        try {
            const date = new Date(datetime);
            // Utiliser getUTCHours/getUTCMinutes pour éviter la conversion timezone
            const hours = date.getUTCHours().toString().padStart(2, '0');
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } catch {
            return '';
        }
    };

    const timeDisplay = item.startTime && item.endTime 
        ? `${formatTime(item.startTime)} - ${formatTime(item.endTime)}`
        : 'Non spécifié';

    return (
        <div className={styles.row}>
            {/* Séance */}
            <div className={styles.col}>
                <div className={styles.sessionName}>
                    {item.sessionName}
                </div>
            </div>
            
            
            {/* Formateur */}
            <div className={styles.col}>
                <div className={styles.teacherName}>
                    <span>{item.teacherName}</span>
                </div>
            </div>
            
            {/* Date */}
            <div className={styles.col}>
                <div className={styles.date}>
                    <span>{item.date}</span>
                </div>
            </div>
            
            {/* Horaires */}
            <div className={styles.col}>
                <div className={styles.time}>
                    {timeDisplay}
                </div>
            </div>
            
            {/* Justification */}
            <div className={styles.col}>
                <div className={item.justification ? 'status-green' : 'status-red'}>
                    {item.justification ? 'Justifiée' : 'Non justifiée'}
                </div>
            </div>

            {/* Actions */}
            <div className={styles.col}>
                <Actions
                    className={styles.actions}
                    classActionsHead={styles.actionsHead}
                    items={actions}
                    small
                />
            </div>
        </div>
    );
};

export default Row;